import { render, staticRenderFns } from "./InmueblesStore.vue?vue&type=template&id=4c610f8a&"
import script from "./InmueblesStore.vue?vue&type=script&lang=js&"
export * from "./InmueblesStore.vue?vue&type=script&lang=js&"
import style0 from "./InmueblesStore.vue?vue&type=style&index=0&id=4c610f8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports